// components/voice/PTTHintBanner.tsx

interface PTTHintBannerProps {
  show: boolean;
}

export function PTTHintBanner({ show }: PTTHintBannerProps) {
  if (!show) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[200] bg-orange-500 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-4 animate-bounce">
      <div className="text-xl font-bold">
        Houd <kbd className="px-3 py-1 bg-white/30 rounded mx-1 text-2xl">SPATIE</kbd> ingedrukt om te praten!
      </div>
    </div>
  );
}
